<template>
  <article
    :tabindex="tabIndex"
    class="indentation-preview"
    :class="wrapperClasses"
  >
    <button
      :aria-label="ariaLabel"
      @click="closePreview"
      class="indentation-preview__close"
    >
      <svg class="close-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </button>
    <div class="indentation-preview__inner" :class="layout.css" v-html="innerHtml" />

    <icon-row
      class="indentation-preview__control"
      :icons="$store.state.breaks"
      @buttonClick="updateView"
    />
  </article>
</template>

<script>
import IconRow from '../icon-row/index.vue'

export default {
  components: {
    IconRow
  },
  data () {
    return {
      text: this.$store.state.preview.de.text,
      credit: this.$store.state.preview.de.credit
    }
  },
  computed: {
    isOpen () {
      return this.$store.state.preview.isOpen
    },
    layout () {
      return this.$store.getters.previewLayout
    },
    tabIndex () {
      return this.isOpen ? '0' : '-1'
    },
    ariaLabel () {
      const lang = this.$store.state.language
      return lang === 'de' ? 'Ansicht schließen' : 'Close view'
    },
    wrapperClasses () {
      return {
        'indentation-preview--hidden': !this.isOpen
      }
    },
    innerHtml () {
      return `${this.text} <footer class="indentation-preview__footer"> ${this.credit}</footer>`
    }
  },
  methods: {
    closePreview () {
      this.$store.commit('togglePreview')
    },
    updateView (id) {
      console.log('Update', id)
      this.$store.dispatch('UPDATE_PREVIEW', id)
    }
  }
}
</script>

<style lang="scss">
.indentation-preview {
  background-color: rgba(248, 242, 227, 0.8);
  position: fixed;
  height: 100vh;
  left: 0;
  overflow-y: scroll;
  transition: transform 0.3s ease-out;
  top: 0;
  width: 100vw;

  &--hidden {
    transform: translateY(101%);
  }
}

.indentation-preview__close {
  align-items: center;
  border-radius: 50%;
  box-shadow: var(--shadow-1);
  display: flex;
  justify-content: center;
  height: 2rem;
  position: fixed;
  right: var(--site-padding);
  top: var(--site-padding);
  width: 2rem;

  .close-icon {
    fill: var(--color-bg);
  }
}

.indentation-preview__inner {
  background-color: var(--color-bg);
  margin: 0 auto;
  max-width: 60ch;
  padding: var(--site-padding) var(--site-padding) 4.5rem;

  &.left-indentation,
  &.floating {
    p {
      margin: 0;
    }
    p + p {
      text-indent: 1.5rem;
    }
  }

  &.horizontal-spacing {
    p + p {
      margin-top: 1rem;
    }
  }

  &.inline-spacing {
    p {
      display: inline;
    }

    p + p {
      margin-left: 2rem;
    }
  }
}

.indentation-preview__footer {
  font-size: 85%;
  text-align: center;
}
</style>
